import http from "../../http-common";
/* eslint-disable */
class PesanVideoService {
  pesanVideoList(page, itemPerPage, keyword) {
    return http.get(
      "/pesan-video/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("deskripsi", data.deskripsi);

    if (data.alamat != null) bodyFormData.append("alamat", data.alamat);

    return http.post("/pesan-video", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("deskripsi", data.deskripsi);

    if (data.alamat != null) bodyFormData.append("alamat", data.alamat);

    return http.put(`/pesan-video/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/pesan-video/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new PesanVideoService();
